import { message } from "antd";
import { makeObservable, observable } from "mobx";
import { get, post } from "../../services/request";
import {
  GET_ROLE_LIST,
  ADD_ROLE,
  EDIT_ROLE,
  DELETE_ROLE,
  GET_PROJECT_APPS,
  BIND_REFURL,
  UNBIND_REFURL,
  GET_ALLAPP,
  GET_APP_BY_ID,
  BATCH_BINDAPP,
} from "../../services/request/urls";
import type { DataNode } from "antd/lib/tree";

export interface RoleInfo {
  id: number;
  name: string;
  code: string;
  des: string;
  key: string;
}
export interface ProjectInfo {
  id: number;
  name: string;
  publicKey: string;
  refUrlAppVoList: {
    id: number;
    name: string;
    key: string;
    sort: number;
    display: number;
    backEndUrl: string;
  }[];
}
export interface Pagination {
  total: number;
  pageSize: number;
  pageNum: number;
}
class RoleStore {
  roles?: RoleInfo[];
  appList?: DataNode[];
  pagination: Pagination = {
    total: 0,
    pageSize: 10,
    pageNum: 1,
  };
  appListSelected: React.Key[];
  appListMap: Map<string, string> = new Map();
  constructor() {
    makeObservable(this, {
      roles: observable,
      pagination: observable,
      appList: observable,
      appListSelected: observable,
    });
    this.appListSelected = [];
  }
  setAppListSelected(arr: React.Key[]) {
    this.appListSelected = [...arr];
  }

  setPagination(obj: Pagination) {
    this.pagination = { ...this.pagination, ...obj };
  }
  async getRoleList(pageNo: number = 1, pageSize: number = 10) {
    const res = await get(GET_ROLE_LIST, { pageNo, pageSize }, true);

    console.log(res);
    if (res?.code !== 1) {
      console.error(res?.message ?? "获取分组列表失败");
      return;
    }

    res.rows.map((item: RoleInfo, index: number, arr: RoleInfo[]) => {
      arr[index].key = String(arr[index].id);
    });
    this.roles = res.rows;
    this.setPagination({
      ...this.pagination,
      total: res.total || 0,
    });
  }

  async addRole(obj: { name: string; code?: string; des?: string }) {
    const res = await post(ADD_ROLE, obj, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "新增失败");
      return;
    }
    message.success("分组新建成功");
    if (this.pagination.total % this.pagination.pageSize === 0) {
      this.setPagination({
        ...this.pagination,
        pageNum: this.pagination.pageNum + 1,
      });
    }
    await this.getRoleList(this.pagination.pageNum, this.pagination.pageSize);
  }
  async editRole(obj: {
    id: number;
    name: string;
    code?: string;
    des?: string;
  }) {
    const res = await post(EDIT_ROLE, obj, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "编辑失败");
      return;
    }
    message.success("分组编辑成功");

    await this.getRoleList(this.pagination.pageNum, this.pagination.pageSize);
  }

  async removeRole(id: number) {
    const res = await post(`${DELETE_ROLE}?id=${id}`, { id }, true);

    if (res?.code !== 1) {
      message.error(res?.message ?? "分组删除失败");
      return;
    }
    message.success("分组删除成功");
    if ((this.pagination.total - 1) % this.pagination.pageSize === 0) {
      this.setPagination({
        ...this.pagination,
        pageNum: this.pagination.pageNum - 1,
      });
    }
    await this.getRoleList(this.pagination.pageNum, this.pagination.pageSize);
  }
  async getAllApp() {
    const res = await get(GET_ALLAPP, null, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "全部应用列表获取失败");
      return;
    }
    const listChild = res.data.map((item: ProjectInfo, index: number) => {
      if (!item?.refUrlAppVoList) {
        return {
          checkable: false,
          title: item.name,
          key: `0-${item.id}`,
        };
      } else {
        const child = item.refUrlAppVoList.map((_item, _index) => {
          this.appListMap.set(`0-${item.id}-${_item.id}`, _item.key);
          return {
            refurlKey: _item.key,
            title: _item.name,
            key: `0-${item.id}-${_item.id}`,
          };
        });
        return {
          // checkable: false,
          title: item.name,
          key: `0-${item.id}`,
          children: child,
        };
      }
    });
    this.appList = [
      {
        title: "全部项目",
        key: "0",
        children: listChild,
      },
    ];
  }
  async getAppByRoleId(id: number) {
    this.appListSelected = [];
    const res = await get(GET_APP_BY_ID, { id }, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "应用列表获取失败");
      return;
    }
    res.data.forEach((item: any, index: number) => {
      if (item.appRoleIdVos?.length !== 0) {
        item.appRoleIdVos.forEach((_item: any, _index: number) => {
          this.appListSelected.push(`0-${item.projectId}-${_item.appId}`);
        });
      }
    });
  }
  async batchBindApp(obj: {
    roleId: number;
    addKey: (undefined | string)[];
    delKey: string[];
  }) {
    const res = await post(BATCH_BINDAPP, obj, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "操作失败");
      return;
    }
    // this.setAppListSelected(this.newAppListSelected);
    message.success("操作成功");
  }
  // async bindApp(obj: { roleId: number; refurlKey: string }) {
  //   const res = await post(BIND_REFURL, obj, true);
  //   if (res?.code !== 1) {
  //     message.error(res?.message ?? "绑定失败");
  //     return;
  //   }
  //   this.setAppListSelected(this.newAppListSelected);
  //   message.success("绑定成功");
  // }
  // async unbindApp(obj: { roleId: number; refurlKey: string }) {
  //   const res = await post(UNBIND_REFURL, obj, true);
  //   if (res?.code !== 1) {
  //     message.error(res?.message ?? "解绑失败");
  //     return;
  //   }
  //   this.setAppListSelected(this.newAppListSelected);
  //   message.success("解绑成功");
  // }
}

export default new RoleStore();
